import React from "react";
import Dropdown from "components/dropdown";
import { Link } from "react-router-dom";
import { BsArrowBarUp } from "react-icons/bs";
import { RiMoonFill, RiSunFill } from "react-icons/ri";
import {
  IoMdNotificationsOutline,
  IoMdInformationCircleOutline,
} from "react-icons/io";
import avatar from "assets/img/avatars/avatar4.png";
import { useDispatch, useSelector } from "react-redux";
import { logoutUser, currentUser } from "services/users/authSlice";
import ApiList from "services/apiList";

const Navbar = (props) => {
  const { brandText } = props;
  const [darkmode, setDarkmode] = React.useState(false);

  const user = useSelector(currentUser);

  const dispatch = useDispatch();
  return (
    <nav className="relative top-4 z-40 flex flex-row flex-wrap items-center justify-between rounded-xl bg-white/10 p-2 backdrop-blur-xl dark:bg-[#0b14374d]">
      <div className="ml-[6px]">
        <div className="overflow-wrap h-6 w-[224px] pt-1">
          <a
            className="text-sm font-normal text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            href=" "
          >
            Хуудас
            <span className="mx-1 text-sm text-navy-700 hover:text-navy-700 dark:text-white">
              {" "}
              /{" "}
            </span>
          </a>
          <Link
            className="overflow-wrap text-sm font-normal capitalize text-navy-700 hover:underline dark:text-white dark:hover:text-white"
            to="#"
          >
            {brandText}
          </Link>
        </div>
        <p className="shrink text-[33px]  text-navy-700 dark:text-white">
          <Link
            to="#"
            className="line-clamp-1 overflow-hidden text-ellipsis font-bold  hover:text-navy-700 dark:hover:text-white"
          >
            {brandText}
          </Link>
        </p>
      </div>

      <div className="relative mt-[3px] flex h-[61px] w-[355px] flex-grow items-center justify-around gap-2 rounded-full bg-white px-2 py-2 shadow-xl shadow-shadow-500 dark:!bg-navy-800 dark:shadow-none md:w-[365px] md:flex-grow-0 md:gap-1 xl:w-[365px] xl:gap-2">
        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdNotificationsOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          animation="origin-[65%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
          children={
            <div className="flex w-[360px] flex-col gap-3 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none sm:w-[460px]">
              <div className="flex items-center justify-between">
                <p className="text-base font-bold text-navy-700 dark:text-white">
                  Мэдэгдэл
                </p>
              </div>

              <button className="flex w-full items-center">
                <div className="flex h-full w-[85px] items-center justify-center rounded-xl bg-gradient-to-b from-brandLinear to-brand-500 py-4 text-2xl text-white">
                  <BsArrowBarUp />
                </div>
                <div className="ml-2 flex h-full w-full flex-col justify-center rounded-lg px-1 text-sm">
                  <p className="mb-1 text-left text-base font-bold text-gray-900 dark:text-white">
                    EDU MONGOLIA:
                  </p>
                  <p className="font-base text-left text-xs text-gray-900 dark:text-white">
                    Системийн эхний хувилбар гарлаа
                  </p>
                </div>
              </button>
            </div>
          }
          classNames={"py-2 top-4 -left-[230px] md:-left-[440px] w-max"}
        />

        <div
          className="cursor-pointer text-gray-600"
          onClick={() => {
            if (darkmode) {
              document.body.classList.remove("dark");
              setDarkmode(false);
            } else {
              document.body.classList.add("dark");
              setDarkmode(true);
            }
          }}
        >
          {darkmode ? (
            <RiSunFill className="h-4 w-4 text-gray-600 dark:text-white" />
          ) : (
            <RiMoonFill className="h-4 w-4 text-gray-600 dark:text-white" />
          )}
        </div>

        <Dropdown
          button={
            <p className="cursor-pointer">
              <IoMdInformationCircleOutline className="h-4 w-4 text-gray-600 dark:text-white" />
            </p>
          }
          children={
            <div className="flex w-[350px] flex-col gap-2 rounded-[20px] bg-white p-4 shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <p className="text-sm font-bold text-navy-700 dark:text-white">
                📜 Хэрэглэгчийн эрхүүд
              </p>
              {user.is_admin ? (
                <p className="ml-4 text-sm font-bold text-navy-700 dark:text-white">
                  👑 Админ
                </p>
              ) : (
                <span></span>
              )}
              {user.is_manager ? (
                <p className="ml-4 text-sm font-bold text-navy-700 dark:text-white">
                  💼 Менежер
                </p>
              ) : (
                <span></span>
              )}
              {user.is_teacher ? (
                <p className="ml-4 text-sm font-bold text-navy-700 dark:text-white">
                  👩🏻‍🏫 Багш
                </p>
              ) : (
                <span></span>
              )}
              {user.is_student ? (
                <p className="ml-4 text-sm font-bold text-navy-700 dark:text-white">
                  👨🏻‍🎓 Сурагч
                </p>
              ) : (
                <span></span>
              )}
              {user.is_food_technologist ? (
                <p className="ml-4 text-sm font-bold text-navy-700 dark:text-white">
                  👨‍🍳 Хоол технологич
                </p>
              ) : (
                <span></span>
              )}
              {user.is_chef ? (
                <p className="ml-4 text-sm font-bold text-navy-700 dark:text-white">
                  👨‍🍳 Тогооч
                </p>
              ) : (
                <span></span>
              )}
              {user.is_parent ? (
                <p className="ml-4 text-sm font-bold text-navy-700 dark:text-white">
                  👨‍👩‍👧 Асран хамгаалагч
                </p>
              ) : (
                <span></span>
              )}
            </div>
          }
          classNames={"py-2 top-6 -left-[250px] md:-left-[330px] w-max"}
          animation="origin-[75%_0%] md:origin-top-right transition-all duration-300 ease-in-out"
        />

        {/* Profile & Dropdown */}
        <Dropdown
          button={
            <img
              className="h-10 w-10 rounded-full"
              src={
                user === null || user === undefined
                  ? avatar
                  : user.profile === "" ||
                    user.profile === null ||
                    user.profile === undefined
                  ? avatar
                  : ApiList.baseMediaUrl + user.profile
              }
              alt={(user.profile === "").toString()}
            />
          }
          children={
            <div className="flex w-56 flex-col justify-start rounded-[20px] bg-white bg-cover bg-no-repeat shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:text-white dark:shadow-none">
              <div className="p-4">
                <div className="flex items-center gap-2">
                  <p className="text-sm font-bold text-navy-700 dark:text-white">
                    👋 Сайн уу?,{" "}
                    {user.firstname === null || user.firstname === undefined
                      ? "Хэрэглэгч"
                      : user.firstname}
                  </p>{" "}
                </div>
              </div>
              <div className="h-px w-full bg-gray-200 dark:bg-white/20 " />

              <div className="flex flex-col p-4">
                <Link
                  to="/admin/profile"
                  className="mb-3 text-left text-sm text-gray-800 dark:text-white hover:dark:text-white"
                >
                  Профайл
                </Link>
                <button
                  onClick={() => {
                    dispatch(logoutUser());
                  }}
                  className="mt-3 text-left text-sm font-medium text-red-500 hover:text-red-500"
                >
                  Гарах
                </button>
              </div>
            </div>
          }
          classNames={"py-2 top-8 -left-[180px] w-max"}
        />
      </div>
    </nav>
  );
};

export default Navbar;
